import { gql } from '@apollo/client';
import {
  VOLUNTEER_COMMUNICATION_EMAIL_FRAGMENT,
  VOLUNTEER_COMMUNICATION_SMS_FRAGMENT,
} from '../../volunteer-common-profile/communications-model.gql';

export const GET_APPLICANT_COMMUNICATIONS = gql`
  query GetApplicantCommunications($userId: String!) {
    em {
      emails(userId: $userId) {
        ...VolunteerCommonProfileEmail
      }
      outboundSms(userId: $userId) {
        ...VolunteerCommonProfileSms
      }
    }
  }

  ${VOLUNTEER_COMMUNICATION_EMAIL_FRAGMENT}
  ${VOLUNTEER_COMMUNICATION_SMS_FRAGMENT}
`;
